import React from 'react';
import PageHeading from '~/components/PageHeading';
import FeatureIntro from '~/components/FeatureIntro';
import Loading from '~/components/Loading';
import useBusinessNavigate from '~/lib/useBusinessNavigate';
import { useCustomQuestionsQuery } from '~/lib/Queries';
import { customQuestionIcon } from '~/lib/CustomQuestions/CustomQuestionIcons';
import { formatDate } from '~/lib/DateTime';

const CustomQuestionsIndexPage = () => {
    const navigate = useBusinessNavigate();
    const { data, isLoading } = useCustomQuestionsQuery();

    const questions = data?.customQuestions || [];

    return (
        <div>
            <PageHeading
                heading="Extensions"
                rightContent={
                    <button
                        type="button"
                        className="btn-pill"
                        onClick={() => navigate('/custom-questions/0')}
                    >
                        New Custom Question
                    </button>
                }
            />

            <FeatureIntro>
                Write your own question types in HTML, CSS and JavaScript, and
                add them to any of your forms from the Add Element panel. They
                run in a sandbox on the form, follow your theme, and can be
                given settings you fill in per form.
            </FeatureIntro>

            {questions.length > 0 && (
                <div className="mt-6 max-w-3xl">
                    <div className="panel pl-4">
                        {questions.map((question, idx) => {
                            const Icon = customQuestionIcon(question.icon);

                            return (
                                <div
                                    key={question.id}
                                    className={`flex items-center justify-between py-3 pr-4 cursor-pointer ${idx > 0 ? 'border-t' : ''}`}
                                    onClick={() =>
                                        navigate(
                                            `/custom-questions/${question.id}`,
                                        )
                                    }
                                >
                                    <div className="flex items-center">
                                        <Icon className="w-8 h-8 p-1.5 rounded mr-3 text-primary-700 bg-primary-50" />
                                        <div>
                                            <div>{question.name}</div>
                                            {!!question.description && (
                                                <div className="text-gray-500 text-sm">
                                                    {question.description}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="text-sm text-gray-500">
                                        {question.updated_at
                                            ? `Updated ${formatDate(question.updated_at)}`
                                            : ''}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {isLoading && <Loading />}

            {!isLoading && questions.length === 0 && (
                <div className="panel">
                    <div className="pt-4 pr-4 pb-4 pl-4 text-gray-500">
                        You haven't created any custom questions yet.
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomQuestionsIndexPage;
